import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';

import { CoreModule } from './core/core.module';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { LayoutModule } from './layout/layout.module';
import { AppInitializerService } from './core/services/app-initializer.service';
import { AuthenticationService } from './core/authentication/authentication.service';
import { PagesModule } from './pages/pages.module';

export function initializeApp(appInitializerService: AppInitializerService) {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    return (): Promise<any> => {
        return appInitializerService.initialize();
    };
}
@NgModule({
    declarations: [AppComponent],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        CoreModule.forRoot(),
        LayoutModule,
        PagesModule,
    ],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = initializeApp(inject(AppInitializerService));
            return initializerFn();
        }),
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            deps: [AuthenticationService],
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
